export default __webpack_public_path__ + "static/media/contact-banner.0133b836.jpg";